<template>
  <div>
      <div class="choice">
      <label class="label list_label">{{inputName}}</label>
      <label class="label" id="select_apply_label">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path d="M10.8 1.3999L3.64043 8.5999L1.19995 6.14562" stroke="#999999" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Select any that apply.
      </label>
      <div class=" columns is-multiline is-mobile">
          <div class="column" style="margin: auto;">
          <div class="options_container">
              <div class="option_container"  :class="fullWidthOption ? 'list-full-option' : ''" v-for="option in Ids" v-bind:key="option.value">
                  <input type="checkbox" :id="option.id" :name="option.id" :value="option.value" @change="selectInput" v-model="selectedOptions">
                  <label class="radio_label" :for="option.id">{{option.value}}</label>
              </div>
            </div>
          </div>
      </div>
      <p class="help is-danger" v-if="field.error">{{ field.error }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Choices",
  model() {
    return { value: "", error: "", typed: false };
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
    options: Array,
    fullWidthOption: Boolean
  },
  data() {
    return {
      field: this.inputField,
      selectedOptions: [],
      Ids: []
    };
  },
  computed: {},
  methods: {
    modified() {
      // console.log('modified');
      console.log('selectedOptions: ', this.selectedOptions);
      // this.field.typed = true;
      this.setValue(this.selectedOptions)
      // this.validate();
    },
    validate() {
      this.field.error = null;
      let valid = false;
      if(this.selectedOptions.length > 0){
        valid = true;
      }
      if (valid == false) {
        this.field.error = "Please select at least one option.";
      }
      return this.field.error == null;
    },
    setValue(s) {
      this.field.value = s;
      // this.modified();
    },
    selectInput(input) {
      this.modified()
      // this.validate();
      this.setUISelected(input);
    },
    setUISelected(event){
      if(event.target.checked){
        $('#'+event.target.id).parent().addClass('selected_radio');
        $('#'+event.target.id).parent().find('.radio_label').addClass('selected_radio_text');
      }else{
        $('#'+event.target.id).parent().removeClass('selected_radio');
        $('#'+event.target.id).parent().find('.radio_label').removeClass('selected_radio_text');
      }
    },
  },
  created: function(){
    this.options.forEach(option => {
      // console.log(option);
      let id = option.replace(/ /g, '_')
      .replace(/</g, '_')
      .replace("+", '_')
      .replace(".", '_')
      .replace("$", '_')
      .replace(",", '_')
      let new_option = { id: id, value: option };
      // console.log(new_option);
      this.Ids.push(new_option);
    });
  },
  mounted: function() {

  }
};
</script>

<style scoped>
.choice {
  padding: 15px;
  padding: 0;
  transition: all 0.5s;
  margin: 5px !important;
  cursor: pointer;
  /* border: 1px solid #1a689b; */
  border-radius: 5px;
}
.selected {
  background: #f0f4ff;
}
#select_apply_label{
  color: #666;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}
</style>

<style scoped>
.column{
  padding-top: 0px;
}
.options_container::after{
  content: "";
  display: table;
  clear: both;
}
.option_container{
  border: 1px solid #CCC;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  white-space: nowrap; /* Prevent wrapping of text */
  height: 47px;
  float: left;
  min-width: 48%;
  margin-right: 2%;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* .option_container:hover{
  border-radius: 8px;
  border: 1px solid #28A745;
  background: #28A745;
}
.option_container:hover label{
  color: white;
} */
.option_container:first-of-type{
  margin-top: 0px !important;
}
input[type="checkbox"]{
  height: 100%;
  width: 1px;
  height: 1px;
  /* Optional for consistent cross-browser styling */
  appearance: none; /* Removes default styling */
  -webkit-appearance: none; /* Safari support */
  background-color: white;
  border: 2px solid grey;
  border-radius: 50%; /* Makes it circular */
  outline: none;
  cursor: pointer;
  transform: scale(0);
}
input[type="radio"]{
  height: 100%;
  width: 1px;
  height: 1px;
  /* Optional for consistent cross-browser styling */
  appearance: none; /* Removes default styling */
  -webkit-appearance: none; /* Safari support */
  background-color: white;
  border: 2px solid grey;
  border-radius: 50%; /* Makes it circular */
  outline: none;
  cursor: pointer;
  transform: scale(0);
}
.option_container input[type="radio"]:checked{
  border-radius: 8px;
  border: 1px solid #28A745;
  background: #28A745;
}
input[type="radio"]:checked {
  /* background-color: rgb(221, 212, 212); //Indicates checked state */
  background-color: #1FB9FD /* Indicates checked state */      
}
.radio_label{
  margin-left: 0px;
  vertical-align: super;
  color: #A5A5A5;
  font-family: Roboto;
  font-size: 0.90rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: inline-block;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.selected_radio{
  border-radius: 8px;
  border: 1px solid #28A745;
  background: #28A745;
}
.selected_radio_text{
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.label{
  font-family: Roboto;
  /* color: #363636; */
}
.list_label{
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.radio_label:hover{
  cursor: pointer;
}
.field {
  padding: 20px 20px;
  background: #edf0f3;
  border-radius: 5px;
  margin: 12px 0px;
}
.choice {
  padding: 15px 0;
  padding-top: 0;
  transition: all 0.75s;
  /* margin: 20px auto 0px !important; */
  /* width:70px; */
  cursor: pointer;
  border: none;
  border-radius: 100px;
}
.cardiff-selected{
  background: #cedbff;
}
.list-full-option{
  width: 100%;
}
@media only screen and (max-width: 1024px) {
  .choice{
    border:none;
    margin-top:0 !important;
    border-radius: 100px;
  }
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  /* .option_container:hover{
    border: 1px solid #CCC;
    border-radius: 4px;
    background-color: white;
  }
  .option_container:hover label{
    color: #A5A5A5;
  } */
}


</style>